export default __webpack_public_path__ + "6b19ed38d6687c86e148bc966d241d43.svg";